import React, { FC, useCallback, useEffect } from 'react';
import { Alert, Text } from 'react-native';
import { ElementBase, IElementBaseProps, initializeElement } from '..';
import { Feather } from "@expo/vector-icons";
import { Box, Icon, Input, InputField, InputSlot, Pressable, Textarea, TextareaInput } from "@gluestack-ui/themed";
import { MarkdownText } from '../base/renderMDText';
import { useVoiceDictation } from '../../utils/useVoiceDictation';

export const TextElement: FC<IElementBaseProps> = (({ ...props }) => {
    const {
        element,
        payload, checkAndSetPayload, errorList
    } = initializeElement(props);

    const handleChange = useCallback((value: string | undefined) => {
        let val = value === undefined ? "" : value.toString();
        if (element.templateData.toChangeCase === "upperCase")
            val = val.toUpperCase();
        if (element.templateData.toChangeCase === "lowerCase")
            val = val.toLowerCase();        
        checkAndSetPayload(val);
    }, []);
    
    if (element.templateData.valueAsTitle && element.templateData.readOnly ){
        element.name=payload.value;
        return <ElementBase errors={errorList} element={element} forReview={props.forReview} link={payload.url}></ElementBase>
    }
    const { 
        isListening, 
        startListening, 
        stopListening, 
        errorType, 
        isSupported 
    } = useVoiceDictation(handleChange);

    useEffect(() => {
        if (errorType === 'NETWORK_ERROR') {
            Alert.alert(
                "Dictado ",
                "Manten apretado mientras dictas.\n\nOFFLINE\nPara usar voz sin conexión, descarga el paquete de español en los ajustes de idioma de tu dispositivo."
            );
        }
        
        //console.log("errorType", errorType)
    }, [errorType]);
    const micPress = () => {
        startListening((txt:any)=>{
            handleChange(((payload.value||"").concat(" ").concat(txt)))
        });
    }
;
    

    let sizeStyle = element.templateData.compactSize ?
        {
            fontSize: 12,
            lineHeight: 16,
            size: "sm" as const,
            paddingVertical: 2,
            inputHeight: 24,
        }
        :
        {
            fontSize: 16,
            lineHeight: 22,
            size: "md" as const,
            paddingVertical: 4,
            inputHeight: 32,
        }
        ;
    const dicButton = isSupported && element.type !== "sendemail" ? (
        <Pressable
            key="recAudio"
            onPressIn={micPress}
            onPressOut={stopListening}
            p="$1"
            hitSlop={8}
        >
            <Icon as={Feather} name="mic" size={sizeStyle.size} />
        </Pressable>
    ) : null;
    const bgColor = isListening
        ? "$red400"
        : element.templateData.readOnly
            ? "transparent"
            : "#00000010";

    return <ElementBase errors={errorList} element={element} forReview={props.forReview} link={payload.url} changedMe={payload.value} rightButton={dicButton}>
        {props.forReview || element.templateData.readOnly ?
            <Text style={{ color: (element.templateData.textColor ? element.templateData.textColor : "#000"), fontWeight: element.templateData.hidden_label ? "bold" : "normal", fontSize: sizeStyle.fontSize, paddingLeft: 7 }}>
                <MarkdownText fontSizeBase={sizeStyle.fontSize}  parser={element.templateData.hasMarkDown ?? false}>{(payload.value)}</MarkdownText>
            </Text>
            :
            <Box>
                {(element.templateData.rowSpan == undefined || element.templateData.rowSpan == 1) ?
                    <Input
                        variant="unstyled"
                        size={sizeStyle.size}
                        isReadOnly={!!element.templateData.readOnly}
                        backgroundColor={bgColor}
                        borderWidth={0}
                        py="$0"
                        px="$2"
                        alignItems="center"
                        height={sizeStyle.inputHeight}
                    >
                        {element.type === "sendemail" && (
                            <InputSlot mr="$3">
                                <Icon as={Feather} name="at-sign" size={sizeStyle.size} />
                            </InputSlot>
                        )}
                        <InputField
                            keyboardType={element.type === "sendemail" ? "email-address" : "default"}
                            color={element.templateData.textColor || "#000"}
                            fontWeight={element.templateData.hidden_label ? "bold" : "normal"}
                            onChangeText={handleChange}
                            placeholder={element.templateData.placeholder || ""}
                            placeholderTextColor="#8C8C8C"
                            value={payload.value?.toString() || ""}
                            maxLength={element.templateData.maxLength}
                            style={{
                                fontSize: sizeStyle.fontSize,
                                lineHeight: sizeStyle.lineHeight,
                                paddingVertical: 0,
                                textAlignVertical: "center",
                                includeFontPadding: false,
                            }}
                            width="100%"
                            paddingHorizontal="$0"
                            py="$0"
                        />
                    </Input>
                    :
                    <Textarea
                        borderWidth={0}
                        py={sizeStyle.paddingVertical}
                        variant={element.templateData.readOnly ? "unstyled" : "default"}
                        isReadOnly={!!element.templateData.readOnly}
                        size={sizeStyle.size}
                        backgroundColor={bgColor}
                    >
                        <TextareaInput
                            maxLength={element.templateData.maxLength}
                            multiline
                            numberOfLines={element.templateData.rowSpan}
                            keyboardType={element.type === "sendemail" ? "email-address" : "default"}
                            color={element.templateData.textColor || "#000"}
                            onChangeText={handleChange}
                            placeholder={element.templateData.placeholder || ""}
                            placeholderTextColor="#8C8C8C"
                            value={payload.value?.toString() || ""}
                            style={{ fontSize: sizeStyle.fontSize }}
                            py={sizeStyle.paddingVertical}
                            paddingHorizontal="$1"
                        />
                    </Textarea>
                }
            </Box>
        }
    </ElementBase>
});
